import { render } from "./ListeRayonPage.vue?vue&type=template&id=1724974a&ts=true"
import script from "./ListeRayonPage.vue?vue&type=script&lang=ts"
export * from "./ListeRayonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__